import { useEffect, useState } from "react";
import api, { apiErrorMessage, formatPLN, formatDate } from "@/lib/api";
import PageHeader from "@/components/PageHeader";
import { toast } from "sonner";
import { Check, X } from "lucide-react";

const STATUS_LABEL = { oczekuje: "Oczekuje", zaakceptowane: "Zaakceptowane", odrzucone: "Odrzucone" };
const STATUS_CLASS = {
  oczekuje: "bg-amber-50 text-amber-700 border-amber-200",
  zaakceptowane: "bg-emerald-50 text-emerald-700 border-emerald-200",
  odrzucone: "bg-red-50 text-red-700 border-red-200",
};

export default function ManagerBudgetRequests() {
  const [list, setList] = useState([]);
  const [comments, setComments] = useState({});

  const reload = () => api.get("/budget-increase-requests").then((r) => setList(r.data));
  useEffect(() => { reload(); }, []);

  const review = async (id, status) => {
    try {
      await api.patch(`/budget-increase-requests/${id}`, { status, manager_comment: comments[id] || null });
      toast.success(status === "zaakceptowane" ? "Wniosek zaakceptowany" : "Wniosek odrzucony");
      reload();
    } catch (e) {
      toast.error(apiErrorMessage(e));
    }
  };

  return (
    <div>
      <PageHeader testId="manager-budget-requests" title="Prośby o zwiększenie budżetu" subtitle={`${list.length} wniosków`} />
      <div className="ol-card overflow-hidden">
        {list.length === 0 ? (
          <div className="p-12 text-center text-sm text-slate-500">Brak wniosków.</div>
        ) : (
          <table className="ol-table" data-testid="budget-requests-table">
            <thead>
              <tr><th>Data</th><th>Pracownik</th><th className="text-right">Obecny</th><th className="text-right">Proponowany</th><th>Powód</th><th>Status</th><th></th></tr>
            </thead>
            <tbody>
              {list.map((r) => (
                <tr key={r.id} className="align-top">
                  <td className="text-xs text-slate-600">{formatDate(r.created_at)}</td>
                  <td>{r.requested_by_name}</td>
                  <td className="text-right">{formatPLN(r.current_budget)}</td>
                  <td className="text-right font-semibold">{formatPLN(r.requested_new_budget)}</td>
                  <td className="max-w-xs"><p className="text-sm text-slate-700">{r.reason}</p></td>
                  <td><span className={`ol-badge border ${STATUS_CLASS[r.status]}`}>{STATUS_LABEL[r.status]}</span></td>
                  <td>
                    {r.status === "oczekuje" ? (
                      <div className="flex flex-col gap-2 w-48">
                        <input
                          placeholder="Komentarz (opcjonalnie)"
                          value={comments[r.id] || ""}
                          onChange={(e) => setComments({ ...comments, [r.id]: e.target.value })}
                          data-testid={`bcomment-${r.id}`}
                          className="px-2 py-1 rounded border border-slate-300 text-xs focus:border-[#FF6B1A] focus:outline-none"
                        />
                        <div className="flex gap-1">
                          <button onClick={() => review(r.id, "zaakceptowane")} data-testid={`bapprove-${r.id}`}
                            className="flex-1 inline-flex items-center justify-center gap-1 px-2 py-1.5 rounded bg-emerald-600 hover:bg-emerald-700 text-white text-xs font-semibold">
                            <Check className="w-3.5 h-3.5" /> Akceptuj
                          </button>
                          <button onClick={() => review(r.id, "odrzucone")} data-testid={`breject-${r.id}`}
                            className="flex-1 inline-flex items-center justify-center gap-1 px-2 py-1.5 rounded bg-white border border-slate-300 hover:bg-slate-50 text-slate-700 text-xs font-semibold">
                            <X className="w-3.5 h-3.5" /> Odrzuć
                          </button>
                        </div>
                      </div>
                    ) : (
                      <span className="text-xs text-slate-400">Rozpatrzone</span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
